import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

// Interface for the data passed to the modal
export interface ModalData {
  title?: string;
  message?: string;
  buttonText?: string;
  type?: 'info' | 'warning' | 'error' | 'success';
  link?: string;
  specific?: boolean;
  width?: string;
  height?: string;
  coming_from_extension?: boolean;
}

@Component({
  selector: 'app-modal-general',
  standalone: true,
  imports: [MatButtonModule, CommonModule, TranslateModule],
  templateUrl: './modal-general.component.html',
  styleUrl: './modal-general.component.scss'
})
export class ModalGeneralComponent {
  constructor(
    public dialogRef: MatDialogRef<ModalGeneralComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalData
  ) {}

  closeModal() {
    this.dialogRef.close();
  }

  closeModalWithResult(result?: any) {
    this.dialogRef.close(result);
  }

  // Static method to open the modal (can be used from any component)
  static open(dialog: MatDialog, data: ModalData) {
    return dialog.open(ModalGeneralComponent, {
      width: data.width || '800px',
      data: data,
      disableClose: false,
      height: data.height || 'auto'
    });
  }
}
